import * as React from 'react';
import {useEffect, useRef} from 'react';

const googleClientId = '960171064324-dmco7h2glijjq7rf5ma5kgogsli9gthn.apps.googleusercontent.com';

export default function ({onSignin}: {
    onSignin: (idToken: string) => void,
}) {
    const googleSignIn = useRef<HTMLDivElement>(null);

    function init () {
        (window as any).google.accounts.id.initialize({
            client_id: googleClientId,
            callback: (res: {credential: string}) => {
                onSignin(res.credential);
            }
        });

        (window as any).google.accounts.id.renderButton(googleSignIn.current, {
            theme: 'filled_blue',
            size: 'large',
        });
    }
    
    useEffect(() => {
        const h = setInterval(() => {
            if ((window as any).google) {
                clearInterval(h);
                init();
            }
        }, 500);
    }, []);

    return <div ref={googleSignIn}/>;
}
